import { render } from "./ReviewVocabulary.vue?vue&type=template&id=7b2c54c6"
import script from "./ReviewVocabulary.vue?vue&type=script&lang=js"
export * from "./ReviewVocabulary.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__